export enum PackageComposition {
  Empty = 'Empty',
  Uniform = 'Uniform',
  Mixed = 'Mixed',
}
